<div class="border-card border-0 px-4 py-1 scroll-container" 
       ref="AnswerRiskAssessment" 
       v-if="assessments.length">
    <NavigationBackButton />

    <div class="card card-nav-tabs border-0 shadow rounded-lg mt-5">
      <div class="card-header card-header-primary rounded-lg border-0">
        <div class="nav-tabs-navigation">
            <div class="nav-tabs-wrapper">
                <ul class="nav nav-tabs" data-tabs="tabs">
                    <li class="nav-item me-3" 
                        v-for="assess in assessments"
                        :key="assess.id"
                        :class="{ 'active': active_assessment === assess.id }"
                        @click="active_assessment = assess.id">
                        <a class="text-white text-decoration-none text-xs nav-link" 
                        href="#profile" 
                        data-toggle="tab">
                            {{ assess.name }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
      </div>

      <div class="mb-2 px-1 py-1">
        <div v-for="assess in assessments" 
             :key="assess.id"
             class="tab-content bg-white"
             :class="{ 'active-content': active_assessment === assess.id }">

          <div class="questions-grid">
            <div class="questions-column">
              <template 
                v-for="q in left_questions(assess.questions)" 
                :key="q.id"
              >
                <div class="question-item mb-3">
                  <div class="question-label fw-500 text-xxs mb-2">
                    {{ q.text }}
                  </div>

                  <!-- single_select -->
                  <div v-if="q.type === 'single_select'" class="list-group mt-1">
                    <label v-for="opt in q.choices" 
                           :key="opt.option" 
                           class="text-xxs d-block mb-1">
                      <input type="radio"
                             :name="'q_' + q.id"
                             :value="opt.option"
                             v-model="answers[q.id]"
                             class="me-1"
                      />
                      {{ opt.option }}
                      <small class="text-muted">({{ opt.weight }} points)</small>
                    </label>
                  </div>

                  <!-- multi_select -->
                  <div v-else-if="q.type === 'multi_select'" class="list-group mt-1">
                    <label v-for="opt in q.choices" 
                           :key="opt.option" 
                           class="text-xxs d-block mb-1">
                      <input type="checkbox"
                             :value="opt.option"
                             v-model="answers[q.id]"
                             class="me-1"
                      />
                      {{ opt.option }}
                      <small class="text-muted">({{ opt.weight }} points)</small>
                    </label>
                  </div>
                </div>
              </template>
            </div>

            <div class="vertical-divider mx-4"></div>

            <div class="questions-column">
              <template 
                v-for="q in right_questions(assess.questions)" 
                :key="q.id"
              >
                <div class="question-item mb-3">
                  <div class="question-label fw-500 text-xxs mb-2">
                    {{ q.text }}
                  </div>

                  <!-- single_select -->
                  <div v-if="q.type === 'single_select'" class="list-group">
                    <label v-for="opt in q.choices" 
                           :key="opt.option" 
                           class="text-xxs d-block mb-1">
                      <input type="radio"
                             :name="'q_' + q.id"
                             :value="opt.option"
                             v-model="answers[q.id]"
                             class="me-1"
                      />
                      {{ opt.option }}
                      <small class="text-muted">({{ opt.weight }} points)</small>
                    </label>
                  </div>

                  <!-- multi_select -->
                  <div v-else-if="q.type === 'multi_select'" class="list-group">
                    <label v-for="opt in q.choices" 
                           :key="opt.option" 
                           class="text-xxs d-block mb-1">
                      <input type="checkbox"
                             :value="opt.option"
                             v-model="answers[q.id]"
                             class="me-1"
                      />
                      {{ opt.option }}
                      <small class="text-muted">({{ opt.weight }} points)</small>
                    </label>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- submit -->
          <div class="d-flex justify-content-end mt-4">
            <button class="btn btn-primary-dark btn-sm px-2 text-xxs shadow"
                    :disabled="submitting"
                    @click="submit_answers">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>

    <AICampusFooter/>
</div>

<div v-else class="text-center py-5 text-muted">
No assessments available.
</div>